import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c48f62e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-6",
  align: "center"
}

import { useI18n } from "vue-i18n"
import { computed, onBeforeUnmount, ref, watch } from "vue"
import { Applicant, DoctorProfile, Student } from "@/types"
import HeaderComponent from "../Header/HeaderComponent.vue"
import router from "@/router"
import { onMounted } from "vue"
import { useUserActions } from "@/stores/user-actions"
import GeneralInformation from "./GeneralInformation/GeneralInformation.vue"
import ApplicationsProfileComponent from "./Applications/ApplicationsProfileComponent.vue"
import FooterComponent from "../Footer/FooterComponent.vue"
import SingleApplication from "../Static/Application/SingleApplication.vue"
import StudentMessages from "./Messages/StudentMessages.vue"
import { broadcastingActions } from "@/stores/broadcasting-store"
import { useRoute } from "vue-router"
import { useMeta } from "vue-meta"

export default /*#__PURE__*/_defineComponent({
  __name: 'StudentProfile',
  setup(__props) {

const { t } = useI18n()

const userAction = useUserActions()
const isLoading = ref(false)
const token = ref(localStorage.getItem("accessToken") ?? "")
const responseStatus = ref({})
const selectedItem = ref<string>("info")
const notifications = ref(0)
const broadcasting = broadcastingActions()
const smallWindow = ref(window.innerWidth < 1000)

const route = useRoute()

onMounted(() => {
  getNotifications()
  navigate((path.value as string) ?? "General Information")
})

onMounted(() => {
  window.addEventListener("resize", updateWindowSize)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
})

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}
const path = computed(() => {
  return route.name
})

const photo = computed(() => {
  return userAction.userProfileLink
})
const name = computed(() => {
  return userAction.name
})
const email = computed(() => {
  return userAction.email
})

watch(path, () => {
  selectedItem.value = path.value as string
})

useMeta(
  computed(() => ({
    title: name.value,
  }))
)

const navigate = (page: string) => {
  selectedItem.value = page
  router.push({ name: page })
}

const getNotifications = async () => {
  const response = await broadcasting.getNotifications()
  responseStatus.value = response
  if (response.success) {
    notifications.value = response.result as number
  }
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createVNode(_component_request_status, {
      class: "mt-6",
      response: responseStatus.value,
      isLoading: isLoading.value
    }, null, 8, ["response", "isLoading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_layout, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_navigation_drawer, {
                    "expand-on-hover": smallWindow.value,
                    rail: smallWindow.value,
                    permanent: !smallWindow.value,
                    "mobile-breakpoint": "xs",
                    width: "260"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, {
                        align: "start",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            "prepend-avatar": 
                photo.value != '' || undefined
                  ? photo.value
                  : require('../../assets/blank.png')
              ,
                            subtitle: email.value,
                            title: name.value
                          }, null, 8, ["prepend-avatar", "subtitle", "title"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      (_openBlock(), _createBlock(_component_v_list, {
                        density: "compact",
                        nav: "",
                        align: "start",
                        key: selectedItem.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-account",
                            title: _ctx.$t('general-info'),
                            class: _normalizeClass({
                'v-list-item--active': selectedItem.value === 'General Information',
                'v-list-item--inactive': selectedItem.value !== 'General Information',
              }),
                            value: "General Information",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate('General Information')))
                          }, null, 8, ["title", "class"]),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-application",
                            title: _ctx.$t('your-applications'),
                            value: "Student Application",
                            class: _normalizeClass({
                'v-list-item--active': selectedItem.value === 'Student Application',
                'v-list-item--inactive': selectedItem.value !== 'Student Application',
              }),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate('Student Application')))
                          }, null, 8, ["title", "class"]),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-email-outline",
                            title: _ctx.$t('your-messages'),
                            value: "Student Messages",
                            class: _normalizeClass({
                'v-list-item--active': selectedItem.value === 'Student Messages',
                'v-list-item--inactive': selectedItem.value !== 'Student Messages',
              }),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate('Student Messages')))
                          }, {
                            append: _withCtx(() => [
                              (notifications.value > 0)
                                ? (_openBlock(), _createBlock(_component_v_badge, {
                                    key: 0,
                                    color: "primary",
                                    content: notifications.value,
                                    inline: ""
                                  }, null, 8, ["content"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["title", "class"])
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  }, 8, ["expand-on-hover", "rail", "permanent"]),
                  _createVNode(_component_v_main, { style: {"min-height":"100vh"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(FooterComponent)
  ], 64))
}
}

})